<template>
  <div class="construction-installation-cost-budget">
    <div class="header">
      <el-button type="primary" size="mini" @click="handleSummary"
        >单项工程建安费汇总</el-button
      >
    </div>
    <SimpleTable
      style="flex: 1"
      ref="constructionInstallationCostBudget"
      table-code="constructionCostBudget"
      :menus="['查询', '批量修改']"
      :bottomFrozenRowCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin'
import SimpleTable from '@/components/SimpleTable/index.vue'
import {
  sortRecords,
  getOptions,
  addCbFn,
  aggregationSUM,
  aggregationAmount
} from '@/utils/index'

export default {
  name: 'ConstructionInstallationCostBudget',
  mixins: [tableMixin],
  components: {
    SimpleTable
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      columns: [
        {
          field: 'projectUnitName',
          title: '单项工程',
          aggregation: aggregationSUM
        },
        {
          field: 'generalContractorAmount',
          title: '施工总包',
          aggregation: aggregationAmount
        },
        {
          field: 'professionalEngineeringAmount',
          title: '专业工程',
          width: 100
        },
        {
          field: 'directDeliveryAmount',
          title: '直接发包'
        },
        {
          field: 'osMaterialAmount',
          title: '甲供材料',
          aggregation: aggregationAmount
        },
        {
          field: 'baseAmount',
          title: '取费基数',
          aggregation: aggregationAmount
        },
        {
          field: 'costRatio',
          title: '取费系数',
          fieldType: 'number',
          canEdit: true
        },
        {
          field: 'generalContractingServiceAmount',
          title: '总包服务费',
          aggregation: aggregationAmount
        },
        {
          field: 'amount',
          title: '合计'
        }
      ],
      loading: false
    }
  },
  watch: {
    basicInfo() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    init() {
      this.getTableData()
    },
    async getTableData() {
      if (!this.basicInfo?.id) return
      this.loading = true
      const res = await this.$service.get(
        `/project-unit-budget/summary/list?budgetId=${this.basicInfo.id}`
      )
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    async handleSummary(row) {
      this.loading = true
      const res = await this.$service.post(
        'project-unit-budget/summary/' + this.basicInfo.id
      )
      if (res.code === 200) {
        this.$message.success('汇总成功')
        this.getTableData()
      }
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-unit-budget/summary/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTableData()
    }
  }
}
</script>

<style scoped lang="less">
.construction-installation-cost-budget {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .header {
    margin-bottom: 10px;
  }
}
</style>
